/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_CompleteInputs */



/**
* | output |
* | --- |
* | "OCR Complete" |
*
* @param {Ocr_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_complete = /** @type {((inputs?: Ocr_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("OCR complet")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("OCR completo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("OCR Complete")
	if (locale === "es") return /** @type {LocalizedString} */ ("OCR completo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR 完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCR完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("OCR completo")
	return /** @type {LocalizedString} */ ("OCR Complete")
});